import React, { Fragment, useEffect, useState } from "react";

import {
  Button,
  Checkbox,
  Grid,
  CardContent,
  IconButton,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  Tooltip,
  Typography,
} from "@mui/material";

import { styled } from "@mui/material/styles";

//icons
import BlockIcon from "@mui/icons-material/Block";
import DeleteIcon from "@mui/icons-material/Delete";
import BackupIcon from "@mui/icons-material/Backup";

//config
import { RutinaLeerArchivoInputFile } from "../../../Utilidades/ManejoArchivos";
import CarpetasAdjuntos from "../../../Configuracion/Llaves/CarpetasAdjuntos";
import { ValidarFormatoArchivo } from "../../../Actions/Utilidades/ValidacionesAction";
import { enlistaArrayCodigosMensajesIdiomas } from "../../../Actions/Generales/IdiomasAction";
import { styleTable, StyleHome } from "../../Tool/Style";
import {
  StyledTableCellClass,
  StyledTableRowClass,
  StyledTableRowHeaderClass,
} from "../../../theme/themeTableRow";
import { MostrarMensaje } from "../../../Utilidades/ManejoMensajes";
import ListadoRequisitosInstitucionales from "../../../Actions/RequisitosInstitucionales/ReqInstAction";

//hook
import { useGlobalState } from "../../../Utilidades/useGlobalState";

//config home
import { MOBILE } from "../config";

//context
import { dispatchAdmision, stateAdmison } from "../Context/store";

const Input = styled("input")({
  display: "none",
});

const RequisitosInstitucionalesMultiple = ({
  deviceIs = "DESKTOP",
  onRequisitosChange,
  setListaRequisitosInstitucionalesProp,
}) => {
  const admisionDispatch = dispatchAdmision();
  const { institutionalRequirementsList = [] } = stateAdmison();
  const [ListaRequisitosInstitucionales, setListaRequisitosInstitucionales] = useState([]);
  const { etiquetas, dispatch,sesionUsuario } = useGlobalState();

  const syncLista = (newList) => {
    setListaRequisitosInstitucionales(newList);
    admisionDispatch({
      type: "changeInstitutionalRequirementsList",
      payload: { institutionalRequirementsList: newList },
    });
    if (typeof onRequisitosChange === "function") {
      onRequisitosChange(newList);
    }
    if (typeof setListaRequisitosInstitucionalesProp === "function") {
      setListaRequisitosInstitucionalesProp(newList);
    }
  };

  useEffect(() => {
    loadRequisitosInstitucionales();
  }, []);

  const loadRequisitosInstitucionales = async () => {
    const payload = {
      PeticionUsuario: null,
      CustomerId: sesionUsuario.usuario.customerId || null
    };
    const response = await ListadoRequisitosInstitucionales(payload);

    if (response && response.status === 200) {
      const dataFormatted = (response.data || []).map((item) => ({
        ...item,
        fileDetail: null,
        fileInfo: null,
      }));
      syncLista(dataFormatted);
    } else {
      if (response && response.data && response.data.errors) {
        const arrayErrores = enlistaArrayCodigosMensajesIdiomas(
          response.data.errors
        );
        MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
      } else {
        MostrarMensaje(dispatch, "error", [response ? response.statusText : ""]);
      }
    }
  };

  const guardarDataArchivo = async (e, requirementIdFk) => {
    const fileInfo = await RutinaLeerArchivoInputFile(e);

    let ProcesarSiguiente = false;

    if (CarpetasAdjuntos.RequisitosInstitucionales !== "") {
      const dataObject = {
        ElementId: requirementIdFk,
        MimeType: fileInfo.tipo,
        ValidateCode: CarpetasAdjuntos.RequisitosInstitucionales,
      };

      await ValidarFormatoArchivo(dataObject).then((response) => {
        if (response && response.status === 200) {
          //si la respuesta fue existosa
          if (response.data === true) {
            ProcesarSiguiente = true;
          } else {
            MostrarMensaje(dispatch, "warning", ["FormartFileError"]);
          }
        } else {
          if (response && response.data && response.data.errors) {
            const arrayErrores = enlistaArrayCodigosMensajesIdiomas(
              response.data.errors
            );
            MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
          } else {
            MostrarMensaje(dispatch, "error", [response ? response.statusText : ""]);
          }
        }
      });
    } else {
      MostrarMensaje(dispatch, "warning", ["FolderRequisitosInstitucionales"]);
    }

    if (ProcesarSiguiente) {
      const updatedList = ListaRequisitosInstitucionales.map((item) =>
        item.requirementId === requirementIdFk
          ? { ...item, fileDetail: fileInfo, fileInfo: fileInfo }
          : item
      );
      syncLista(updatedList);
    }
  };

  const inputhandleClick = (event) => {
    const { target = {} } = event || {};
    target.value = "";
  };

  const handleChangeAccept = (requirementId, checked) => {
    const updatedList = ListaRequisitosInstitucionales.map((item) =>
      item.requirementId === requirementId
        ? {
            ...item,
            ircAcceptedByCustomer: checked,
          }
        : item
    );
    syncLista(updatedList);
  };

  const abrirNuevoTab = (url) => {
    // Abrir nuevo tab
    var win = window.open(url, "_blank");
    // Cambiar el foco al nuevo tab (punto opcional)
    win.focus();
  };

  const eliminarArchivo = (aprProgramReqId) => {
    const updatedList = ListaRequisitosInstitucionales.map((item) =>
      item.requirementId === aprProgramReqId
        ? {
            ...item,
            fileDetail: null,
            fileInfo: null,
          }
        : item
    );
    syncLista(updatedList);
  };

  return (
    <Fragment>
      <CardContent sx={{ padding: deviceIs === MOBILE ? 0 : "initial" }}>
        <Grid
          key="GridRequisitosInstitucioanlMultiple"
          container
          style={StyleHome.GridConteiner}
        >
          <Grid item xs={12} sm={12} md={12} style={StyleHome.GridItem}>
            {deviceIs === MOBILE ? (
              <div style={{ display: "flex", flexDirection: "column" }}>
                {ListaRequisitosInstitucionales.length > 0
                  ? ListaRequisitosInstitucionales.map((registro) => (
                      <div key={registro.requirementId + "mobile"}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <div style={{marginLeft:'-7px'}}>
                            {registro.acceptRequirement ? (
                              <Checkbox
                                style={{ padding: "0px 5px" }}
                                checked={registro.ircAcceptedByCustomer}
                                name="ircAcceptedByCustomer"
                                color="primary"
                                inputProps={{
                                  "aria-label": "secondary checkbox",
                                }}
                                onChange={(e) => {
                                  handleChangeAccept(
                                    registro.requirementId,
                                    e.target.checked
                                  );
                                }}
                              />
                            ) : null}
                          </div>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography sx={StyleHome.textPrimary}>
                            {etiquetas.General.Et_Requisito}
                          </Typography>

                          <div>
                            {!(registro.hyperlink === "") &&
                            !(registro.hyperlink === null) ? (
                              <Button
                                variant="text"
                                onClick={() =>
                                  abrirNuevoTab(registro.hyperlink)
                                }
                                style={{
                                  textTransform: "inherit",
                                  textDecoration: "underline",
                                  color: "#283593",
                                  fontWeight: "normal",
                                }}
                              >
                                {registro.requirementName}
                              </Button>
                            ) : (
                                <Typography sx={StyleHome.textSecondary}>
                                    {registro.requirementName}
                                </Typography>
                            )}
                          </div>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography sx={StyleHome.textPrimary}>
                            {etiquetas.Home.Et_lblDocumento}:
                          </Typography>

                          <div>
                            {registro.fileRequired === false ? (
                              etiquetas.General.Et_NoAplica
                            ) : (
                              <Tooltip title={etiquetas.Home.Et_lblAdjuntar}>
                                <div>
                                  <label
                                    htmlFor={
                                      "button-file-" +
                                      registro.requirementId
                                    }
                                  >
                                    <Input
                                      id={
                                        "button-file-" +
                                        registro.requirementId
                                      }
                                      type="file"
                                      disabled={registro.fileDetail}
                                      onChange={(e) => {
                                        guardarDataArchivo(
                                          e,
                                          registro.requirementId
                                        );
                                      }}
                                      onClick={inputhandleClick}
                                    />
                                    <Button
                                      disabled={registro.fileDetail}
                                      fullWidth
                                      sx={{
                                        backgroundColor: "#F6F8FB",
                                        color: "#283593",
                                        border: "1px solid #283593",
                                        "&:hover": {
                                          backgroundColor: "#EDF0F4",
                                        },
                                      }}
                                      id="attachments"
                                      variant="contained"
                                      component="span"
                                      disableElevation
                                      startIcon={
                                        <BackupIcon
                                          style={{ color: "#283593" }}
                                        />
                                      }
                                    >
                                      <Typography
                                        noWrap
                                        style={{
                                          color: "#283593",
                                          width: 80,
                                          backgroundColor: "transparent",
                                        }}
                                      >
                                        {registro.fileDetail
                                          ? registro.fileDetail?.nombre
                                          : etiquetas.Home.Et_lblAdjuntar}
                                      </Typography>
                                    </Button>
                                  </label>
                                </div>
                              </Tooltip>
                            )}
                          </div>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography sx={StyleHome.textPrimary}>
                            {etiquetas.General.Et_tblAcciones}:
                          </Typography>

                          {registro.fileRequired === false ? (
                            <IconButton style={styleTable.BodyButtoms} disabled>
                              <BlockIcon fontSize="normal" />
                            </IconButton>
                          ) : (
                            <Tooltip title={etiquetas.General.Et_tbnEliminar}>
                              <IconButton
                                disabled={!registro.fileDetail}
                                onClick={() =>
                                  eliminarArchivo(registro.requirementId)
                                }
                                style={styleTable.BodyButtoms}
                              >
                                <DeleteIcon fontSize="normal" />
                              </IconButton>
                            </Tooltip>
                          )}
                        </div>
                      </div>
                    ))
                  : null}
              </div>
            ) : (
              <TableContainer
                component={Grid}
                style={styleTable.TableConteiner}
              >
                <Table stickyHeader>
                  <TableHead style={styleTable.TableHeader}>
                    <StyledTableRowHeaderClass>
                      <StyledTableCellClass>
                        {etiquetas.General.Et_Requisito }
                      </StyledTableCellClass>
                      <StyledTableCellClass width="150px" Align="center">
                        {etiquetas.Home.Et_lblDocumento}
                      </StyledTableCellClass>
                      <StyledTableCellClass width="85px" Align="center">
                        {etiquetas.General.Et_tbnEliminar}
                      </StyledTableCellClass>
                    </StyledTableRowHeaderClass>
                  </TableHead>
                  <TableBody>
                    {ListaRequisitosInstitucionales.length > 0 ? (
                      ListaRequisitosInstitucionales.map((registro) => {
                        return (
                          <StyledTableRowClass key={registro.requirementId}>
                            <StyledTableCellClass component="th" scope="row">
                              {
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "flex-start",
                                    alignItems: "center",
                                  }}
                                >
                                  <div>
                                    {registro.acceptRequirement ? (
                                      <Checkbox
                                        style={{ padding: "0px 5px" }}
                                        checked={registro.ircAcceptedByCustomer}
                                        name="ircAcceptedByCustomer"
                                        color="primary"
                                        inputProps={{
                                          "aria-label": "secondary checkbox",
                                        }}
                                        onChange={(e) => {
                                          handleChangeAccept(
                                            registro.requirementId,
                                            e.target.checked
                                          );
                                        }}
                                      />
                                    ) : null}
                                  </div>

                                  <div>
                                    {!(registro.hyperlink === "") &&
                                    !(registro.hyperlink === null) ? (
                                      <Button
                                        variant="text"
                                        onClick={() =>
                                          abrirNuevoTab(registro.hyperlink)
                                        }
                                        style={{
                                          textTransform: "inherit",
                                          textDecoration: "underline",
                                          color: "#283593",
                                          fontWeight: "normal",
                                        }}
                                      >
                                        {registro.requirementName}
                                      </Button>
                                    ) : (
                                      registro.requirementName
                                    )}
                                  </div>
                                </div>
                              }
                            </StyledTableCellClass>

                            <StyledTableCellClass width="150px" Align="center">
                              {registro.fileRequired === false ? (
                                etiquetas.General.Et_NoAplica
                              ) : (
                                <Tooltip title={etiquetas.Home.Et_lblAdjuntar}>
                                  <div>
                                    <label
                                      htmlFor={
                                        "button-file-" +
                                        registro.requirementId
                                      }
                                    >
                                      <Input
                                        id={
                                          "button-file-" +
                                          registro.requirementId
                                        }
                                        type="file"
                                        disabled={registro.fileDetail}
                                        onChange={(e) => {
                                          guardarDataArchivo(
                                            e,
                                            registro.requirementId
                                          );
                                        }}
                                        onClick={inputhandleClick}
                                      />
                                      <Button
                                        disabled={registro.fileDetail}
                                        fullWidth
                                        sx={{
                                          backgroundColor: "#F6F8FB",
                                          color: "#283593",
                                          border: "1px solid #283593",
                                          "&:hover": {
                                            backgroundColor: "#EDF0F4",
                                          },
                                        }}
                                        id="attachments"
                                        variant="contained"
                                        component="span"
                                        disableElevation
                                        startIcon={
                                          <BackupIcon
                                            style={{ color: "#283593" }}
                                          />
                                        }
                                      >
                                        <Typography
                                          noWrap
                                          style={{
                                            color: "#283593",
                                            width: 80,
                                            backgroundColor: "transparent",
                                          }}
                                        >
                                          {registro.fileDetail
                                            ? registro.fileDetail?.nombre
                                            : etiquetas.Home.Et_lblAdjuntar}
                                        </Typography>
                                      </Button>
                                    </label>
                                  </div>
                                </Tooltip>
                              )}
                            </StyledTableCellClass>
                            <StyledTableCellClass width="85px" Align="center">
                              <div style={styleTable.BodyContainerButtoms}>
                                {registro.fileRequired === false ? (
                                  <IconButton
                                    style={styleTable.BodyButtoms}
                                    disabled
                                  >
                                    <BlockIcon fontSize="normal" />
                                  </IconButton>
                                ) : (
                                  <Tooltip
                                    title={etiquetas.General.Et_tbnEliminar}
                                  >
                                    <IconButton
                                      disabled={!registro.fileDetail}
                                      onClick={() =>
                                        eliminarArchivo(
                                          registro.requirementId
                                        )
                                      }
                                      style={styleTable.BodyButtoms}
                                    >
                                      <DeleteIcon fontSize="normal" />
                                    </IconButton>
                                  </Tooltip>
                                )}
                              </div>
                            </StyledTableCellClass>
                          </StyledTableRowClass>
                        );
                      })
                    ) : (
                      <StyledTableRowClass>
                        <StyledTableCellClass colSpan={3}>
                          {etiquetas.General.Et_tblTableEmty}
                        </StyledTableCellClass>
                      </StyledTableRowClass>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </Grid>
        </Grid>
      </CardContent>
    </Fragment>
  );
};

export default RequisitosInstitucionalesMultiple;
